import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ReturnStore } from '../model/ReturnStore';

@Injectable()
export class ReturnStoreFacade {
    
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAllReturnStore(): Observable<RequestResponse<any[]>> {
        return this._httpClient.get<RequestResponse<any[]>>(this._urlBase + 'api/ReturnStore/All');
    }

    GetReturnStoreByStoreDates(storeOriginId: number, startDate: string, endDate: string) {
        return this._httpClient.get<RequestResponse<ReturnStore[]>>(this._urlBase + 'api/ReturnStore/ByStoreDates?storeId=' + storeOriginId + '&startDate=' + startDate + '&endDate=' + endDate)
    }

    GetReturnStoreDetail(returnStoreId, language: number): Observable<RequestResponse<any>> {
        return this._httpClient.get<RequestResponse<any>>(this._urlBase + 'api/ReturnStore/Detail?returnStoreId='+returnStoreId+'&&language='+language);
    }
}
